<template lang="pug">
  .gifts-show(:class="giftPage.designType")
    img(v-if="giftPage.mainImage" :src="giftPage.mainImageSet.mdImage" :alt="`${giftPage.name}のメイン画像`"  class="gift-page-image")
    div(v-for="giftPageBody in giftPage.publishedGiftPageBodies" :id="`outline${giftPageBody.id}`" class="outline" :key="giftPageBody.id")
      template(v-if="giftPageBody.bodyType === 'menu'")
        SectionMenu(:giftPageBody="giftPageBody" :giftPageBodies="giftPage.giftPageBodies")
      template(v-else-if="giftPageBody.bodyType === 'ranking'")
        SectionRanking(:giftPageBody="giftPageBody")
      template(v-else-if="giftPageBody.bodyType === 'budget'")
        SectionBudget(:giftPageBody="giftPageBody")
      template(v-else-if="giftPageBody.bodyType === 'free'")
        SectionFree(:giftPageBody="giftPageBody")
      template(v-else-if="giftPageBody.bodyType === 'category'")
        SectionCategory(:giftPageBody="giftPageBody")
      template(v-else-if="giftPageBody.bodyType === 'recommend'")
        SectionRecommend(:giftPageBody="giftPageBody")
      //- タグ
      template(v-else-if="giftPageBody.bodyType === 'tag'")
        SectionTag(:giftPageBody="giftPageBody" :giftPageName="giftPage.name" :giftPageCode="giftPage.code" )
      //- カテゴリ商品
      template(v-else-if="giftPageBody.bodyType === 'category_item'")
        SectionCategoryItem(:giftPageBody="giftPageBody" :giftPageName="giftPage.name" :giftPageCode="giftPage.code" )
      //- 目次
      template(v-else-if="giftPageBody.bodyType === 'outline'")
        SectionOutline(:giftPageBodies="giftPage.publishedGiftPageBodies")
    SectionItemArchive.mt-lg
</template>

<script>
  import { GetGiftPageForApi } from '../../graphqls/Gifts'
  import GlobalMixin from '../../mixin/GlobalMixin'
  import SectionBudget from '../../components/v1/gift/SectionBudget'
  import SectionCategory from '../../components/v1/gift/SectionCategory'
  import SectionFree from '../../components/v1/gift/SectionFree'
  import SectionMenu from '../../components/v1/gift/SectionMenu'
  import SectionRanking from '../../components/v1/gift/SectionRanking'
  import SectionRecommend from '../../components/v1/gift/SectionRecommend'
  import SectionOutline from '../../components/v1/gift/SectionOutline'
  import SectionItemArchive from '../../components/v1/section/SectionItemArchive'
  import SectionTag from "../../components/v1/gift/SectionTag";
  import SectionCategoryItem from "../../components/v1/gift/SectionCategoryItem.vue";

  export default {
    name: 'GiftsShow',
    mixins: [GlobalMixin],
    components: {
      SectionCategoryItem,
      SectionTag,
      SectionBudget,
      SectionCategory,
      SectionFree,
      SectionMenu,
      SectionRanking,
      SectionRecommend,
      SectionItemArchive,
      SectionOutline
    },
    metaInfo() {
      return {
        script: [{
          type: 'application/ld+json',
          json: {
            '@context': 'http://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: this.$_itemListElement
          }
        }]
      }
    },
    data() {
      return {
        giftPage: {
          mainImage: ''
        }
      }
    },
    mounted: function () {
      // サイドメニュー表示
      this.showSide()
      // クーポン表示
      this.showCommonCoupon()
      // ギフトページ取得
      this.fetchGiftPage()
    },
    methods: {
      async fetchGiftPage () {
        this.loadingStart()
        const { data } = await this.$apollo
        .query({
          query: GetGiftPageForApi,
          variables: {
            code: this.$route.params.code
          },
          client: 'apiClient'
        })
        this.giftPage = data.giftPage
        // パンくずリストを設定
        this.setBreadcrumbs({ breadcrumbs: [
          {
            path: '/',
            name: 'TOP',
          },
          {
            path: `/gifts/${this.giftPage.code}/`,
            name: this.giftPage.name,
          },
        ]})
        this.loadingStop()
        // URL ハッシュ（例 #outline339）付きアクセス時、本文ブロック描画後に該当位置へスクロール
        this.$nextTick(() => {
          if (this.$route.hash && document.querySelector(this.$route.hash)) {
            this.$scrollTo(this.$route.hash, 500, { offset: -110 })
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "../../../../assets/stylesheets/v1/styles";
.gift-page-image {
  display: block;
  margin: 0 auto;
  width: 100%;
  max-width: 800px;
  height: auto;
  @include margin-bottom(lg);
}

.outline {
  +.outline {
    @include margin-top(xxlg);
  }
}
</style>